module.exports = __webpack_public_path__ + "static/media/icon-tx-warning.37f1f958.svg";